<!DOCTYPE html>
<html lang="pt-br">
<head>
    <meta charset="UTF-8">
    <title>Missão, visão e valores</title>
</head>
<body>
    <section>
        <div class="content">
            <div class="textBox">
                <h2>Missão</h2>
                <br/>
                <p>Alcançar um consumo mais consciente exige esforço por parte da população, é claro, mas é também papel das cidades e de seus respectivos governos fazer com que o ODS seja alcançado.</p>
                <p>A nossa missão é sermos reconhecidos como uma rede social que promove a reutilização de objetos como forma de proporcionar bem-estar para os doadores e os favorecidos. Ou seja, para todos os usuários da plataforma.</p>
            </div>
            <div class="imgBox">
                <img src="https://imgur.com/lp3m1zI.jpg.png" width="550" height="550" class="imagem1">
            </div>
        </div>
    </section>
</body>
</html>